import { render, staticRenderFns } from "./PublicLists.vue?vue&type=template&id=9ea140f2"
import script from "./PublicLists.vue?vue&type=script&setup=true&lang=ts"
export * from "./PublicLists.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports